// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1dSOv","content":"ManualTimeModal_content__siNK-"};